import {
  Box,
  Divider,
  Grid,
  Pagination,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useMemo, useState } from "react";
import { adminAxiosInstance } from "src/api/axios";
import PageContainer from "src/components/container/PageContainer";
import AdminFilterBox from "./AdminFilterBox";
import CollapsibleTable from "./components/CollapsibleTable";
import CSVButton from "./components/CSVButton";

const report_headers = [
  { label: "Report", key: "name" },
  { label: "Created On", key: "date_created" },
  { label: "UserId", key: "details.user_id.user_id" },
  { label: "User", key: "details.user_id.name" },
  { label: "Product", key: "details.product_id.title" },
  { label: "LeadId", key: "details.leads.id" },
  { label: "Status", key: "details.status" },
  { label: "Amount(INR)", key: "details.paid_amount" },
  { label: "Total Paid(INR)", key: "paid" },
  { label: "Conversions", key: "total_conversion" },
  { label: "Rejected", key: "rejected" },
  { label: "Incomplete", key: "incomplete" },
];

function AdminReports() {
  const limit = 50;
  const [parsedReport, setParsedReport] = useState([]);
  const [reportFilter, setReportFilter] = useState("");
  const [firstReportDateFilter, setfirstReportDateFilter] = useState(moment());
  const [secondReportDateFilter, setsecondReportDateFilter] = useState(
    moment().add(-2, "day")
  );
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [loader, setLoader] = useState(true);
  const [csvLimit, setCsvLimit] = useState(500);
  const [details, setDetails] = useState([]);

  const transformer = (data) => {
    const parsedRows = [];
    for (let i of data) {
      if (i && i?.details) {
        for (let item of i?.details) {
          let { user_id, product_id, leads, status, due, paid } = item;
          let temp = {
            name: i.name,
            user_id: user_id?.user_id,
            user: user_id?.name,
            product: product_id?.title,
            lead_id: leads?._id,
            status,
            paid,
            due,
            Agg_paid: i?.paid,
            conversions: i?.total_conversion,
            rejected: i?.rejected,
            incomplete: i?.incomplete,
          };
          parsedRows.push(temp);
        }
      }
    }
    return parsedRows;
  };

  const fetch = (resetPage = false) => {
    setDetails([]);
    setLoader(true);
    adminAxiosInstance
      .get(
        `/ref/reports?search=${reportFilter}&dateStart=${firstReportDateFilter}&dateEnd=${secondReportDateFilter}&page=${page}&limit=${limit}`
      )
      .then((report) => {
        if (report?.status === 200) {
          console.log(report);
          setDetails(report.data.results);
          setCount(report.data.count);
          setLoader(false);

          setLoader(false);
          if (resetPage) {
            setPage(1);
          }
        }
      })
      .catch((e) => {
        console.log(e);
        setLoader(false);
        setDetails([]);
        setCount(0);
      });
  };

  useMemo(() => {
    fetch();
  }, []);

  const filterInputs = [
    {
      type: "text",
      name: "Campaign Name",
      state: reportFilter,
      setState: setReportFilter,
      function: () => {
        fetch(true);
      },
    },
    {
      type: "date",
      dateStart: firstReportDateFilter,
      dateEnd: secondReportDateFilter,
      setDateStart: setfirstReportDateFilter,
      setDateEnd: setsecondReportDateFilter,
      function: () => {
        fetch(true);
      },
    },
  ];

  return (
    <PageContainer
      title="Reports | EarnPati"
      description="this is Earnpati Admin Reports"
      sx={{ maxWidth: { xs: "100vw", lg: "70vw" } }}
    >
      <Grid container spacing={1} sx={{ padding: "0 .5rem" }}>
        <Typography variant="h3" sx={{ my: 1 }}>
          Reports History
        </Typography>

        <Grid item xs={12}>
          <AdminFilterBox inputs={filterInputs} submitFunction={fetch} />
          <Box></Box>
          <Grid item>
            <Stack direction="row" justifyContent={"space-between"}>
              <p>
                Showing data of past:{" "}
                {parseInt(
                  moment
                    .duration(firstReportDateFilter - secondReportDateFilter)
                    .asDays()
                )}{" "}
                days
              </p>
              <Stack direction={"row"}>
                <p sx={{ mt: "15px" }}>Limit:</p>
                <TextField
                  sx={{ width: "25%", margin: "5px" }}
                  type="number"
                  placeholder={`Limit`}
                  value={csvLimit}
                  onChange={(e) => setCsvLimit(e.target.value)}
                />
                <CSVButton
                  csvData={parsedReport}
                  setCsvData={setParsedReport}
                  transformer={transformer}
                  csv_download_url={`/ref/reports?search=${reportFilter}&dateStart=${firstReportDateFilter}&dateEnd=${secondReportDateFilter}&page=${page}&limit=${csvLimit}`}
                  data_key={"results"}
                  headers={report_headers}
                  filename={`report_history_${reportFilter}_${new Date().toDateString()}.csv`}
                />
              </Stack>
            </Stack>
          </Grid>
        </Grid>
        <Divider sx={{ my: 1 }} />
        <Box>
          {(details?.length && (
            <CollapsibleTable details={details} loader={loader} />
          )) || (
            <Stack
              justifyContent={"center"}
              alignItems={"center"}
              sx={{ width: "75vw", height: "30vh" }}
            >
              <Typography variant="h4" sx={{ textAlign: "center" }}>
                No Data Found
              </Typography>
            </Stack>
          )}
        </Box>
      </Grid>
      <Stack direction="row" alignItems={"center"} justifyContent={"center"}>
        <Pagination
          count={Math.round(count / limit) || 1}
          onChange={(e, value) => setPage(value)}
        ></Pagination>
      </Stack>
    </PageContainer>
  );
}

export default AdminReports;
